import { EMPTY_SHOP_PHONE } from "@/utils/storePhones.js";
import IOSToggle from "@/components/IOSToggle.jsx";
import "./phone-fields.css";

const MAX_PHONES = 5;

export default function ShopPhoneFields({ phones, onChange, idPrefix = "shop-phone" }) {
    const updatePhone = (index, field, value) => {
        const next = phones.map((phone, phoneIndex) => (
            phoneIndex === index ? { ...phone, [field]: value } : phone
        ));
        onChange(next);
    };

    const addPhone = () => {
        if (phones.length >= MAX_PHONES) {
            return;
        }
        onChange([...phones, { ...EMPTY_SHOP_PHONE }]);
    };

    const removePhone = (index) => {
        if (phones.length <= 1) {
            onChange([{ ...EMPTY_SHOP_PHONE }]);
            return;
        }
        onChange(phones.filter((_, phoneIndex) => phoneIndex !== index));
    };

    return (
        <div className="phone-fields">
            <div className="phone-fields-header">
                <span>Numéros de téléphone (optionnel)</span>
                {phones.length < MAX_PHONES && (
                    <button type="button" className="link-btn" onClick={addPhone}>
                        Ajouter un numéro
                    </button>
                )}
            </div>
            {phones.map((phone, index) => (
                <div key={`${idPrefix}-${index}`} className="phone-fields-row shop-phone-fields-row">
                    <label className="field">
                        Numéro {index + 1}
                        <input
                            value={phone.phoneNumber}
                            onChange={(event) => updatePhone(index, "phoneNumber", event.target.value)}
                            placeholder="+237 6XX XX XX XX"
                        />
                    </label>
                    <IOSToggle
                        id={`${idPrefix}-${index}-whatsapp`}
                        className="website-shop-phone-whatsapp"
                        label="Disponible sur WhatsApp"
                        checked={phone.whatsappEnabled === true}
                        onChange={(whatsappEnabled) => updatePhone(index, "whatsappEnabled", whatsappEnabled)}
                    />
                    {phones.length > 1 && (
                        <button
                            type="button"
                            className="link-btn phone-fields-remove"
                            onClick={() => removePhone(index)}
                        >
                            Supprimer
                        </button>
                    )}
                </div>
            ))}
        </div>
    );
}
